module.exports = __webpack_public_path__ + "img/aeilo-1.168b3662.jpg";